import { useCallback } from "react";
import {
  useTypedParams,
  useTypedSearchParams,
} from "react-router-typesafe-routes";

import { ClientEmployeesCard } from "@components/Cards";
import { ClientEmployeeViewMode } from "@components/Tables";

import { Tabs } from "@design-system/Tabs/Tabs";

import { PortalSubNavigationTabs } from "@layouts/PortalPage/PortalSubNavigationTabs";

import { routes } from "@pages/routes";

export const ClientEmployees = () => {
  const { clientId } = useTypedParams(
    routes.portal.clients.client.clientEmployees,
  );
  const [searchParams, setSearchParams] = useTypedSearchParams(
    routes.portal.clients.client.clientEmployees,
  );
  const viewMode: ClientEmployeeViewMode =
    searchParams.viewMode === "archived" ? "archived" : "active";

  const handleViewModeChange = useCallback(
    (nextViewMode: ClientEmployeeViewMode) => {
      setSearchParams(
        (prev) => ({
          ...prev,
          viewMode: nextViewMode === "archived" ? "archived" : undefined,
        }),
        { untypedSearchParams: true },
      );
    },
    [setSearchParams],
  );

  return (
    <>
      <PortalSubNavigationTabs>
        <Tabs style={{ borderBottom: "none", gap: "24px" }}>
          <Tabs.Tab
            name="Active"
            isActive={viewMode === "active"}
            onClick={() => handleViewModeChange("active")}
          />
          <Tabs.Tab
            name="Archived"
            isActive={viewMode === "archived"}
            onClick={() => handleViewModeChange("archived")}
          />
        </Tabs>
      </PortalSubNavigationTabs>
      <ClientEmployeesCard clientId={clientId} viewMode={viewMode} />
    </>
  );
};
